<p>Resource Adjustments</p>
